import React from 'react';
import { rootActions, useAppDispatch } from '../../data/store';

const SearchIconButton = () => {

    const dispatch = useAppDispatch();

    const openPopup = async () => {
        dispatch(
            rootActions.main({
                searchIconPopupShown: true,
            })
        );
    };

    return (
        <button
            type="button"
            className={ `bg-blue-800 hover:bg-blue-900 text-gray-100 rounded-full pl-12 pr-6 py-3 text-xl whitespace-nowrap transition duration-150 ease-out hover:ease-in` }
            onClick={ openPopup }>
                <span>Search Icon</span>
                <span className="text-cyan-200 text-sm mx-4">NEW</span>
        </button>
        )
    };

export default SearchIconButton;